'use strict';

/**
 *
 * @name: suggestionsGroup
 *
 */

import DirectiveTemplate from './nn-suggestions-group.directive.html';
import './nn-suggestions-group.directive.scss';

function SuggestionsGroupDirective(
  apiPostService,
  transObject,
  $rootScope,
  $translate
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {

      scope.item = scope.content();

      scope.onAnalyticsClick = post => {
        $rootScope.analytics.videoAM('suggestions group', scope.item.title, post);
      }

      function terminate() {
        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        !scope.item.jsonData.sources[0].order ||
        !scope.item.jsonData.sources[0].order[0]) {

        return terminate();
      }

      if (!scope.item.title) {

        $rootScope.$on('$translateChangeSuccess', function() {

          scope.item.title = $translate.instant('SELECTED_FOR_YOU');
        });
      }

      apiPostService
        .getPost(false, scope.item.jsonData.sources[0].order[0], 1, 9)
        .then(function(res) {

          res.data.items.forEach(function(item) {

            transObject.translate(item);
            transObject.getDuration(item);
            transObject.trueSlug(item);
            transObject.isPublished(item);
          });

          scope.posts = res.data.items;

          scope.loaded = true;
        });
    }
  };
}

export default SuggestionsGroupDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-suggestions-group/nn-suggestions-group.directive.js